<template>
  <div id="main">
    <!-- 表头动态展示 -->
    <el-table v-loading="dataListLoading"
              :data="dataList"
              row-key="menuId"
              border
              style="width: 100%;"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name"
                       :label="$t('menu.name')"
                       header-align="center"
                       width="150"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="icon"
                       :label="$t('menu.icon')"
                       align="center">
        <template slot-scope="scope">
          <svg class="icon-svg"
               aria-hidden="true">
            <use :xlink:href="`#${scope.row.icon}`"></use>
          </svg>
        </template>
      </el-table-column>
      <el-table-column prop="type"
                       :label="$t('menu.type')"
                       align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === '0'"
                  size="small">{{ $t('menu.type0') }}</el-tag>
          <el-tag v-else-if="scope.row.type === '1'"
                  size="small">{{ $t('menu.type1') }}</el-tag>
          <el-tag v-else
                  size="small">{{ $t('menu.type2') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="menuUrl"
                       :label="$t('menu.url')"
                       header-align="center"
                       align="center"
                       width="150"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="menuSwitch"
                       label="是否开启"
                       header-align="center"
                       align="center"
                       width="150"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.menuSwitch === true"
                  size="small">已开启</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('handle')"
                       fixed="right"
                       header-align="center"
                       align="center"
                       width="100">
        <template slot-scope="scope">
          <el-dropdown v-show="scope.row.type === '1'" trigger="click"
                       placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('user.operation') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="addUpdate(scope.row)">{{ $t('update') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  /**
   * @author zhengf
   */
  export default {
    name: "maintainList",
    mixins: [mixinViewModule],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/sysmenuswitch/getList',
          getDataListIsMenu: true,
        },
        dataList2:[
          {
            "sys_code": "",
            "icon": "",
            "nameCn": "首页",
            "nameEn": "index",
            "menuSwitch": true,
            "title": "",
            "type": "",
            "children": [],
            "content": "",
            "parentId": "",
            "spread": "",
            "hide": "",
            "urls": "",
            "menuUrl": "joylearning.bmw.com.cn",
            "name": "首页",
            "menuId": "0",
            "perms": "",
            "id": "512",
            "order_num": ""
          },
          {
            "sys_code": "",
            "icon": "icon-setting",
            "nameCn": "基础管理",
            "nameEn": "Common Management",
            "menuSwitch": null,
            "title": "",
            "type": "0",
            "children": [
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "参数管理",
                "nameEn": "Parameter Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/config/list,/sys/config/update",
                "menuUrl": "sys/config",
                "name": "参数管理",
                "menuId": "6",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "省市管理",
                "nameEn": "Administrative Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commregion/info/*,/sys/commregion/update,/sys/commregion/list,/sys/commregion/save/*,/sys/commregion/delete",
                "menuUrl": "sys/commregion",
                "name": "省市管理",
                "menuId": "7",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "字典管理",
                "nameEn": "Dictionary Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commdict/list,/sys/commdict/info/*,/sys/commdict/update,/sys/commdict/save,/sys/commdict/delete",
                "menuUrl": "sys/dict",
                "name": "字典管理",
                "menuId": "8",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "标签设置",
                "nameEn": "Label Setting",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commlabel/bussinessList,/sys/commlabel/save,/sys/commlabel/labelList,/sys/commlabel/info/*,/sys/commlabel/bussinessInfo/*,/sys/commlabel/update,/sys/commlabel/delete",
                "menuUrl": "sys/label",
                "name": "标签设置",
                "menuId": "11",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "菜单管理",
                "nameEn": "Menu Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/menu/list,/sys/menu/info/*,/sys/menu/getChildrenlist,/sys/menu/update,/sys/menu/save,/sys/menu/delete",
                "menuUrl": "sys/menu",
                "name": "菜单管理",
                "menuId": "13",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "普通邮件管理",
                "nameEn": "Common Mail Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "/sys/commmail/list",
                "menuUrl": "sys/mail",
                "name": "普通邮件管理",
                "menuId": "21",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "积分管理",
                "nameEn": "Point Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "",
                "menuUrl": "",
                "name": "积分管理",
                "menuId": "98",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "标签数据管理",
                "nameEn": "BusinessDataMaintainance",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commbusinessdata/list,/sys/commbusinessdata/save,/sys/commbusinessdata/info/*,/sys/businessdata/update",
                "menuUrl": "sys/businessdata",
                "name": "标签数据管理",
                "menuId": "197",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "日志管理",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "https://testjoylearning.bmw.com.cn/loger/#/login",
                "menuUrl": "https://testjoylearning.bmw.com.cn/loger/#/login",
                "name": "日志管理",
                "menuId": "200109",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-doubleright",
                "nameCn": "定时任务",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "",
                "menuUrl": "task/schedulejob",
                "name": "定时任务",
                "menuId": "200225",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "",
                "nameCn": "定时任务新增",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "",
                "menuUrl": "task/schedulejobAdd",
                "name": "定时任务新增",
                "menuId": "200226",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "",
                "nameCn": "定时任务修改",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "",
                "menuUrl": "task/schedulejobUpdate",
                "name": "定时任务修改",
                "menuId": "200227",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "",
                "nameCn": "定时任务日志",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "",
                "menuUrl": "task/schedulejoblog",
                "name": "定时任务日志",
                "menuId": "200228",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "勋章管理",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "https://testjoylearning.bmw.com.cn:444/main?menu_url=/page/medal/medalList",
                "menuUrl": "https://testjoylearning.bmw.com.cn:444/main?menu_url=/page/medal/medalList",
                "name": "勋章管理",
                "menuId": "200245",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-filter",
                "nameCn": "红绿灯",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "/acdc/acheKeyMngPositionLightCalc/generateReport,/acdc/acheKeyMngPositionLightCalc/listExecJobResult,/sys/config/update",
                "menuUrl": "/acdc/report/redGreenReport",
                "name": "红绿灯",
                "menuId": "200308",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-alert",
                "nameCn": "维护升级管理",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "1",
                "urls": "",
                "menuUrl": "sys/maintain/maintainList",
                "name": "维护升级管理",
                "menuId": "200318",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "",
                "nameCn": "维护升级修改",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "",
                "menuUrl": "sys/maintain/maintainUpdate",
                "name": "维护升级修改",
                "menuId": "200319",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "",
                "nameCn": "维护升级",
                "nameEn": "",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "1",
                "spread": "0",
                "hide": "0",
                "urls": "",
                "menuUrl": "/sys/maintain/maintainInfo",
                "name": "维护升级",
                "menuId": "200320",
                "perms": "",
                "id": "",
                "order_num": ""
              }
            ],
            "content": "",
            "parentId": "0",
            "spread": "0",
            "hide": "1",
            "urls": "",
            "menuUrl": "",
            "name": "基础管理",
            "menuId": "1",
            "perms": "",
            "id": "",
            "order_num": ""
          },
          {
            "sys_code": "",
            "icon": "icon-idcard",
            "nameCn": "组织用户管理",
            "nameEn": "Organization and User Management",
            "menuSwitch": null,
            "title": "",
            "type": "0",
            "children": [
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "职位管理",
                "nameEn": "Position Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commposition/list,/sys/commbussinessdefine/allList,/sys/commposition/info/*,/sys/commlabel/list,/sys/commposition/update,/sys/commposition/partJobsListUpdate,/sys/commposition/partJobsListSave,/sys/commposition/save,/sys/commposition/delete,/sys/org/selectOrgByParam,/sys/commposition/export,/sys/commposition/candidatePosition",
                "menuUrl": "sys/position",
                "name": "职位管理",
                "menuId": "9",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "角色管理",
                "nameEn": "Role Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/role/list,/sys/org/selectOrg,/sys/menu/selectMenuList,/sys/role/selectActivity,/sys/role/update,/sys/role/info/*,/sys/role/save,/sys/commuser/commPosition,/sys/role/getUser,/sys/role/getAllocatedUser,/sys/role/allocationUser,/sys/role/deleteAllocationUser,/sys/role/queryPositionByType/*,/sys/role/delete,/sys/role/queryPositionByType",
                "menuUrl": "sys/role",
                "name": "角色管理",
                "menuId": "12",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "用户管理",
                "nameEn": "User Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commuser/list,/sys/org/selectOrg,/sys/commuser/getRoleList,/sys/commuser/commPosition,/sys/commuser/permissible,/talent/talentpool/exportPDF,/sys/role/queryPositionByType,/sys/org/selectOrgList,/talent/talentpool/queryWarterMarkInfo,/talent/talentpool/queryResumeInfo",
                "menuUrl": "sys/user",
                "name": "用户管理",
                "menuId": "31",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "组织管理",
                "nameEn": "Organization Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/org/list,/sys/org/selectDealerGroupByParam,/sys/org/validateOrgInfo,/sys/org/export",
                "menuUrl": "sys/organization",
                "name": "组织管理",
                "menuId": "41",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "离职反馈",
                "nameEn": "Dimission FeedBack",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "0",
                "urls": "/sys/dimission/list",
                "menuUrl": "sys/dimission",
                "name": "离职反馈",
                "menuId": "51",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "区域经理管理",
                "nameEn": "AreaManager Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "/sys/commAreaManager/areaPosition,/sys/org/queryOutletList,/sys/commAreaManager/update,/sys/commAreaManager/list,/sys/commAreaManager/info/*,/sys/commAreaManager/save,/sys/commAreaManager/queryUser,",
                "menuUrl": "sys/areamanager",
                "name": "区域经理管理",
                "menuId": "96",
                "perms": "",
                "id": "",
                "order_num": ""
              },
              {
                "sys_code": "",
                "icon": "icon-menu",
                "nameCn": "组群管理",
                "nameEn": "Group Management",
                "menuSwitch": false,
                "title": "",
                "type": "1",
                "childMenuList": [],
                "content": "",
                "parentId": "2",
                "spread": "0",
                "hide": "1",
                "urls": "https://testjoylearning.bmw.com.cn:444/main?menu_url=/group",
                "menuUrl": "https://testjoylearning.bmw.com.cn:444/main?menu_url=/group",
                "name": "组群管理",
                "menuId": "97",
                "perms": "",
                "id": "",
                "order_num": ""
              }
            ],
            "content": "",
            "parentId": "0",
            "spread": "0",
            "hide": "1",
            "urls": "/sys/commquickmenu/info/**,/sys/menu/selectSysCodeMenuList",
            "menuUrl": "",
            "name": "组织用户管理",
            "menuId": "2",
            "perms": "",
            "id": "",
            "order_num": ""
          },
        ]
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      // 数据初始化
      init() {
        console.log('init')
      },

      addUpdate(row){
        let query = {}
        query.menuUrl = row != null ? row.menuUrl : undefined
        query.menuName = row != null ? row.menuName : undefined
        this.$router.push({
          name: 'sys-maintain-maintainUpdate',
          query: {
            menuUrl : row.menuUrl,
            menuName : row.name,
            menuId : row.menuId
          }
        })
      },

    },

    //创建前：
    beforeCreate() {
      console.log('beforeCreate')
    },
    // 创建完成 实例已经创建完成之后被调用
    created() {
      console.log('created')
    },
    //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
    beforeMount() {
      console.log('beforeMount')
    },
    // 挂载完成：
    mounted() {
      this.init()
      console.log(this.dataList)
    },
    // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() {
      console.log('beforeUpdate')
    },
    // 更新成功
    updated() {
      console.log('updated')
    },
    // 实例销毁之前调用
    beforeDestroy() {
      console.log('beforeDestroy')
    },
    //Vue 实例销毁后调用
    destroyed() {
      console.log('destroyed')
    }

  }
</script>

<style scoped>
  @import "../../../css/pkg-styles.css";

</style>
